import { ZONES_LIST, ZONES_LOADING } from '../actions';

const INITIAL_STATE = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
    loading: false,
};

const zones = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ZONES_LOADING:
            return { ...state, loading: true };
        case ZONES_LIST:
            return {
                ...state,
                ...action.list,
                loading: false,
            };
        default:
            return state;
    }
};
export default zones;
